import React from 'react';

const COMMUNITY_LINKS = [
  {
    title: 'Discord',
    url: 'https://discord.com/invite/ZduXSdd',
    icon: '/img/community/discord_solid.png',
    color: '#5865F2',
  },
  {
    title: 'Telegram',
    url: 'https://t.me/surf_finance',
    icon: '/img/community/telegram_solid.png',
    color: '#25A3E1',
  },
  {
    title: 'Twitter',
    url: 'https://twitter.com/surf_defi',
    icon: '/img/community/twitter_solid.png',
    color: '#1B9DF0',
  },
  {
    title: 'Reddit',
    url: 'https://www.reddit.com/r/SurfFinance',
    icon: '/img/community/reddit_solid.png',
    color: '#FF4500',
  },
];

const renderCommunityLinks = () =>
  COMMUNITY_LINKS.map(({ title, url, icon, color }) => (
    <a
      key={title}
      href={url}
      title={title}
      className="block uppercase text-xs md:text-sm text-center"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img className="-mt-8 md:-mt-10 w-10 h-10 md:w-16 md:h-16 mx-auto" src={icon} alt={title} />
      <span className="block pt-2 md:pt-4" style={{ color }}>
        {title}
      </span>
    </a>
  ));

const Community = () => {
  return (
    <>
      <img src="img/community/surfers_text.png" className="rounded-lg" alt="" />
      <div className="md:hidden grid grid-cols-4">{renderCommunityLinks()}</div>
      <div className="hidden md:flex justify-center space-x-28 tracking-widest">
        {renderCommunityLinks()}
      </div>
    </>
  );
};
export default Community;
